/*
播放语音的Modal
 */

import React from "react";
import { Row, Col, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";

import Threads from "./VoiceThreadsView/VoiceThreadsView";
import "./VoiceModalStyles.css"

const VoiceModal = ({ open, isMobile, isGotVoice, voiceModalClosed }) => {
    return (
        <div>
            {open &&
                <div className={isMobile ? "mobile-voice-modal" : "pc-voice-modal"}>
                    <Row justify="center" align="middle" style={{ marginTop: "5px" }}>
                        <Col span={23} style={{ display: "flex", justifyContent: "end" }}>
                            <Button type="text" icon={<CloseOutlined style={{ color: "#fff" }} />} size="small" onClick={voiceModalClosed} />
                        </Col>
                    </Row>
                    <Row justify="center" align="middle">
                        <Col span={23}>
                            <Threads
                                amplitude={isGotVoice ? 1 : 0}
                                distance={0}
                                enableMouseInteraction={false}
                            />
                        </Col>
                    </Row>
                </div>
            }
        </div>
    );
};
export default VoiceModal;
